import { z } from 'zod';
import { uuidSchema, pageCursorSchema } from './common.js';
import { orgContactFieldsSchema, orgPreferenceFieldsSchema, orgProfileSchema } from './client-profile.js';

export const sellerListResponseSchema = z.object({
  data: z.array(z.object({
    sellerOrgId: uuidSchema,
    legalName: z.string(),
    shortName: z.string().nullable(),
    isTest: z.boolean(),
  })),
});
export type SellerListResponse = z.infer<typeof sellerListResponseSchema>;

export const sellerDetailSchema = z.object({
  sellerOrgId: uuidSchema,
  legalName: z.string(),
  shortName: z.string().nullable(),
  contactEmail: z.string().nullable(),
  contactPhone: z.string().nullable(),
  website: z.string().nullable(),
  description: z.string().nullable(),
  address: orgContactFieldsSchema.shape.address,
  poolNote: z.string().nullable(),
  prefAssetClasses: orgProfileSchema.shape.prefAssetClasses,
  prefManufacturers: orgProfileSchema.shape.prefManufacturers,
  prefRegions: orgProfileSchema.shape.prefRegions,
  prefShippingMethods: orgProfileSchema.shape.prefShippingMethods,
  prefDcCapability: orgProfileSchema.shape.prefDcCapability,
  prefServices: orgProfileSchema.shape.prefServices,
  isActive: z.boolean(),
  isTest: z.boolean(),
  createdAt: z.string(),
  assetCount: z.number(),
  transactionCount: z.number(),
  /** RUF-538: profileCompleteness() predicate over PROFILE_COMPLETENESS_COLUMNS */
  complete: z.boolean(),
  missingFields: z.array(z.string()),
});

export type SellerDetail = z.infer<typeof sellerDetailSchema>;

export const sellerDetailResponseSchema = z.object({
  data: sellerDetailSchema,
});
export type SellerDetailResponse = z.infer<typeof sellerDetailResponseSchema>;

export const sellerListDetailResponseSchema = z.object({
  data: z.array(sellerDetailSchema),
  nextCursor: pageCursorSchema.nullable(),
});
export type SellerListDetailResponse = z.infer<typeof sellerListDetailResponseSchema>;

export const sellerCreateSchema = z.object({
  legalName: z.string().min(1).optional(),
  shortName: z.string().optional(),
}).merge(orgContactFieldsSchema).merge(orgPreferenceFieldsSchema);
export type SellerCreate = z.infer<typeof sellerCreateSchema>;

export const sellerUpdateSchema = sellerCreateSchema.partial();
export type SellerUpdate = z.infer<typeof sellerUpdateSchema>;
